import { calculateMaxDaresByPlatform, calculateMaxDaresForBestPlatform, } from 'root/src/shared/util/calculateMaxDares';
import { useDropEvent } from 'root/src/client/logic/dropEvent/hooks/useDropEvent';
import { DarePlatform } from 'root/src/shared/@types/platforms';
import { useUserCreatorData, useCreatorFollowersCountByPlatform, useMaxCreatorFollowerCount, } from 'root/src/client/logic/auth/hooks/useUser';
import { getClassifiedDarePlatform, isDareAnyPlatform, } from 'root/src/shared/drops/helpers/dropDare.helpers';
export function useMaxDaresByPlatforms(params = {}) {
    var _a, _b;
    const { platforms = Object.values(DarePlatform), fallbackDrop } = params;
    const { connectedPlatforms, averageCcv, } = useUserCreatorData();
    const maxFollowerCount = useMaxCreatorFollowerCount();
    const followerCountByPlatform = useCreatorFollowersCountByPlatform();
    const campaign = (_a = useDropEvent()) !== null && _a !== void 0 ? _a : fallbackDrop;
    if (!campaign) {
        return 0;
    }
    if (isDareAnyPlatform({ platforms })) {
        const bestPlatform = calculateMaxDaresForBestPlatform({
            followerCount: maxFollowerCount || 0,
            averageCcv: averageCcv || 0,
            campaign,
            connectedPlatforms,
        });
        return (_b = bestPlatform === null || bestPlatform === void 0 ? void 0 : bestPlatform.maxDares) !== null && _b !== void 0 ? _b : 0;
    }
    const maxDaresByPlatform = platforms.map((darePlatform) => {
        const darePlatformClassified = getClassifiedDarePlatform(darePlatform);
        if (!darePlatformClassified) {
            return campaign.dares
                .filter(dare => dare.platforms.includes(darePlatform)).length;
        }
        if (!connectedPlatforms.includes(darePlatformClassified)) {
            return 0;
        }
        return calculateMaxDaresByPlatform({
            platform: darePlatformClassified,
            averageCcv: averageCcv || 0,
            followerCount: (followerCountByPlatform === null || followerCountByPlatform === void 0 ? void 0 : followerCountByPlatform[darePlatformClassified]) || 0,
            campaign,
        });
    });
    return Math.max(...maxDaresByPlatform);
}
